import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 16px;
`;

StyledForm.displayName = 'StyledForm';

export const StyledIndentedFieldGroup = styled(StyledFlex)`
   padding-left: 24px;
`;

StyledIndentedFieldGroup.displayName = 'StyledIndentedFieldGroup';
